<template>
    <div class="page">
        <div class="topBox">
            <!-- <div class="topTitle">NEWS</div> -->
            <!-- <div class="topTitle2">新闻动态</div> -->
            <!-- <div class="line"></div> -->
        </div>
        <pageBreadcrumb :option="nav_option" />
        <div class="search">
            <div class="wrap">
                <div class="searchBigBox">
                    <div class="searchBox">
                        <input type="text" v-model="keyword" class="searchInput" :placeholder="$t('请输入搜索关键词')" />
                        <div class="searchIcon" @click="queryBtn"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="swtichBox">
            <div class="wrap">
                <div class="switchFlexBox">
                    <div class="switchBtn" @click="switchPageType(0)" :class="{ active: !!(pageType == 0) }">{{ $t('企业新闻') }}</div>
                    <div class="lineText">|</div>
                    <div class="switchBtn" @click="switchPageType(1)" :class="{ active: !!(pageType == 1) }">{{ $t('行业资讯') }}</div>
                </div>
            </div>
        </div>

        <div class="listBigBox" v-show="list.length > 0">
            <div class="wrap">
                <div class="listItemBox" @click="goNewsDetail(item)" v-for="(item, index) in list" :key="item.id">
                    <el-image class="listItemImg" :src="item.thumb" fit="contain"></el-image>
                    <div class="rightBox">
                        <div class="title">{{ lang == 'en' ? item.enTitle : item.title }}</div>
                        <div class="contentText">
                            {{ lang == 'en' ? item.enDescription : item.description }}
                        </div>
                        <div class="addFlexBox">
                            <div class="addIcon"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-empty :description="$t('没有查询到相关信息...')" v-if="list.length == 0"></el-empty>

        <div class="wrap" v-if="list.length > 0">
            <el-pagination
                class="elpagination"
                background
                layout="prev, pager, next"
                :total="count"
                :current-page="page"
                :page-size="pageNum"
                @current-change="changePage"
            >
            </el-pagination>
        </div>
        <div class="fill100"></div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import pageBreadcrumb from '@/components/page/page-breadcrumb.vue'

export default {
    name: 'news',
    components: {
        pageBreadcrumb,
    },
    data() {
        return {
            nav_option: [
                { title: '首页', path: '/' },
                { title: '新闻动态', path: '' },
            ],
            count: 0,
            page: 1,
            pageNum: 10,
            list: [],
            keyword: '',

            pageType: 0, // 页面状态：0.企业新闻，1.行业资讯
            pageTypeId: {
                newsId: '',
                dynamicId: '',
            }, // 企业新闻和行业动态的id，newsId：企业新闻id，dynamicId：行业资讯id
        }
    },
    computed: {
        ...mapState([]),
    },
    watch: {
        '$route.query.keyword'() {
            location.reload()
        },
    },
    async created() {
        if (this.$route.query.keyword) {
            this.keyword = this.$route.query.keyword
        }
        this.nav_option = [
            { title: this.$t('首页'), path: '/' },
            { title: this.$t('新闻动态'), path: '' },
        ]
        let res = await this.getNewsChannelAjax()
        if (res) {
            for (let index = 0; index < res.length; index++) {
                let item = res[index]
                if (item.id == 49) {
                    if (item.child) {
                        let list = item.child
                        for (let index2 = 0; index2 < list.length; index2++) {
                            let item2 = list[index2]
                            if (item2.id == 50) {
                                this.pageTypeId.newsId = item2.id
                            } else if (item2.id == 51) {
                                this.pageTypeId.dynamicId = item2.id
                            }
                        }
                        this.getList()
                    }
                    break
                }
            }
        } else {
            alertErr('类别获取失败')
        }
    },
    methods: {
        queryBtn() {
            this.page = 1
            this.getList()
        },
        async getList() {
            let pageType = this.pageType
            let id
            if (pageType == 0) {
                // 企业新闻
                id = this.pageTypeId.newsId
            } else if (pageType == 1) {
                // 行业资讯
                id = this.pageTypeId.dynamicId
            }

            let obj = {
                keyword: this.keyword,
                channelId: id,
                page: this.page,
                pageNum: this.pageNum,
            }
            // this.$load.open()
            let res = await this.getNewsListsAjax(obj)
            // this.$load.close()
            if (res) {
                let resData = res.data
                this.count = resData.count
                this.list = resData.list
            } else {
                alertErr('列表获取失败')
            }
        },
        goNewsDetail(item) {
            this.$router.push({
                path: '/newsDetail',
                query: {
                    id: item.id,
                },
            })
        },
        switchPageType(type) {
            this.pageType = type
            this.page = 1
            this.getList()
            this.$nextTick(() => {
                window.scrollTo({
                    top: 400,
                    left: 0,
                    behavior: 'smooth', // 可选，平滑滚动效果
                })
            })
        },
        changePage(index) {
            this.page = index
            this.getList()
            this.$nextTick(() => {
                window.scrollTo({
                    top: 400,
                    left: 0,
                    behavior: 'smooth', // 可选，平滑滚动效果
                })
            })
        },
        getNewsListsAjax(obj) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'news_lists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else {
                        resolve(false)
                    }
                })
            })
        },
        getNewsChannelAjax() {
            return new Promise((resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'news_channel',
                    },
                }).then((res) => {
                    let { code, data } = res
                    if (code == 200) {
                        resolve(data)
                    } else {
                        resolve(false)
                    }
                })
            })
        },
    },
}
</script>

<style scoped lang="less">
.topBox {
    width: 100%;
    height: 400px;
    background: url('../../assets/img/news/newBg.png') no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    margin-bottom: 50px;

    .topTitle {
        width: 100%;
        text-align: center;
        margin-top: 100px;
        font-size: 55px;
        line-height: 55px;
        color: #ffffff;
        font-family: 'myTextStyle';
        // margin-bottom: 23px;
        margin-bottom: 110px;
    }

    .topTitle2 {
        width: 100%;
        text-align: center;
        font-weight: bold;
        font-size: 55px;
        line-height: 55px;
        color: #ffffff;
        margin-bottom: 110px;
    }

    .line {
        width: 155px;
        height: 3px;
        background: #ffffff;
        margin: 0 auto;
    }
}

.search {
    margin-top: -30px;

    .searchBigBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        overflow: hidden;

        .searchBox {
            width: 380px;
            height: 40px;
            background: #eeeeee;
            border-radius: 100px 100px 100px 100px;
            border: 1px solid rgba(112, 112, 112, 0.6);
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 16px;

            .searchInput {
                width: 300px;
                font-weight: 500;
                font-size: 16px;
                color: #555555;
                line-height: 40px;
                background: transparent;
            }

            .searchIcon {
                width: 18px;
                height: 18px;
                background: url('../../assets/img/artist/query.png') no-repeat;
                background-size: 100% 100%;
                cursor: pointer;
            }
        }
    }
}

.wrap {
    width: @width;
    overflow: hidden;
    margin: 0 auto;
}

.listBigBox {
    margin-bottom: 60px;

    .listItemBox {
        width: 100%;
        height: 263px;
        background: #ffffff;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid rgba(112, 112, 112, 0.4);
        margin-bottom: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        overflow: hidden;

        .listItemImg {
            width: 400px;
            height: 263px;
        }

        .rightBox {
            width: 100%;
            height: 263px;
            padding: 38px 47px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-direction: column;

            .title {
                width: 100%;
                font-weight: 400;
                font-size: 25px;
                color: #000000;
                line-height: 30px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            .contentText {
                width: 100%;
                font-weight: 400;
                font-size: 15px;
                color: #555555;
                line-height: 25px;
            }

            .addFlexBox {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;

                .addIcon {
                    width: 43px;
                    height: 43px;
                    background: url('../../assets/img/news/add.png') no-repeat;
                    background-size: 100% 100%;
                }
            }
        }

        &:last-child {
            margin-bottom: 0;
        }

        &:hover {
            .title {
                color: #ff4d00;
            }

            .addFlexBox {
                .addIcon {
                    background: url('../../assets/img/news/add2.png') no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
    }
}

.swtichBox {
    width: 100%;
    margin-top: 24px;
    margin-bottom: 142px;

    .switchFlexBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .switchBtn {
            font-weight: 400;
            font-size: 20px;
            color: #000000;
            line-height: 34px;
            cursor: pointer;

            &:hover {
                font-weight: bold;
                color: #ff4d00;
            }

            &.active {
                font-weight: bold;
                color: #ff4d00;
            }
        }

        .lineText {
            font-weight: 400;
            font-size: 20px;
            color: #000000;
            line-height: 34px;
            margin: 0 30px;
        }
    }
}

.elpagination {
    text-align: center;
}

.fill100 {
    width: 100%;
    height: 100px;
}
</style>
<style scoped lang="less" src="@/assets/h5css/mobile/news.less"></style>
